import { useState } from 'react';
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';

interface ColorTypeProps {
  onCLick: (groupIndex: number, index: number) => void;
  color: string;
  groupIndex: number;
  index: number;
  active: boolean;
}
const ColorType = (props: ColorTypeProps) => {
  const { groupIndex, index, color, active } = props;
  return (
    <div
      onClick={() => props.onCLick(groupIndex, index)}
      css={
        css`
          cursor: pointer;
          background-color: ${color};
          width: 40px;
          height: 40px;
          ${
            active ?
              `outline: 1px dotted #212121;
              outline: 5px auto -webkit-focus-ring-color;`
            : ''
          }
      `}
    ></div>
  )
};

interface SettingsProps {
  setSettings: (settings: Object) => void;
}

export const Settings = (props: SettingsProps) => {
  const [ maxTurns, setMaxTurns ] = useState(10);
  const [ currColorIdx, setCurrColorIdx ] = useState({groupIndex: 0, index: 0});

  const handleButtonCLick = () => {
    if (!(maxTurns > 0)) {
      return;
    }

    const color = colors[currColorIdx.groupIndex][currColorIdx.index];

    props.setSettings({
      color,
      maxTurns,
    });
  };

  const handleMaxTurnsChange = (event: any) => {
    let value = event.target.value;
    setMaxTurns(parseInt(value));
  };

  const handleColorChange = (groupIndex: number, index: number) => {
    setCurrColorIdx({ groupIndex, index });
  };

  const colors = [
    [
      '#61dafb', // blue
      '#31ce57', // green
      '#f7b43e', // orange
      '#e6ec5a', // yellow
    ],
    [
      '#e65959', // red
      '#c22df1', // purple
      '#f175d4', // pink
      '#ffffff', // white
    ]
  ];

  return (
    <Form>
      <FormGroup>
        <Label >Pick a Color</Label>
        {
          colors.map((colorGroup, groupIndex) => {
            return (
              <div key={groupIndex} css={css`display: flex; justify-content: space-between; padding: 10px 0px;`}>
                {
                  colorGroup.map((color, index) => (
                    <ColorType
                      active={
                        currColorIdx.groupIndex === groupIndex &&
                        currColorIdx.index === index
                      }
                      key={index}
                      groupIndex={groupIndex}
                      index={index}
                      color={color}
                      onCLick={handleColorChange}
                    />
                  ))
                }
              </div>
            );
          })
        }
        {/* <div css={css`display: flex; justify-content: space-between; padding: 10px 0px;`}>
          <ColorType color={'#61dafb'} onCLick={handleColorChange} />
          <ColorType color={'#31ce57'} onCLick={handleColorChange} />
          <ColorType color={'#f7b43e'} onCLick={handleColorChange} />
          <ColorType color={'#e6ec5a'} onCLick={handleColorChange} />
        </div>
        <div css={css`display: flex; justify-content: space-between; padding: 10px 0px;`}>
          <ColorType color={'#e65959'} onCLick={handleColorChange} />
          <ColorType color={'#c22df1'} onCLick={handleColorChange} />
          <ColorType color={'#f175d4'} onCLick={handleColorChange} />
          <ColorType color={'#fff'} onCLick={handleColorChange} />
        </div> */}
        <Label for="maxTurns">Number of Turns</Label>
        <Input
          value={maxTurns}
          onChange={handleMaxTurnsChange}
          type="number"
          name="maxTurns"
          id="maxTurns"
          placeholder="4"
        />
      </FormGroup>
      <Button onClick={handleButtonCLick}>Start</Button>
    </Form>
  );
};
